import type { PastBox, UpcomingBox, FAQItem } from './types'
export const pastBoxes: PastBox[] = [
  {
    id: 1,
    name: "April 2023: 'Midnight Rendezvous'",
    boxName: 'Bookish & Spice',
    theme: 'Steamy Paranormal Romance',
    description:
      'Our April box featured dark and steamy paranormal romances with vampires, shifters, and forbidden love.',
    image:
      'https://images.unsplash.com/photo-1603162361777-1f802e442ecf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800',
    books: [
      {
        title: 'Midnight Embrace',
        author: 'Selene Morgan',
        authorId: 'selene-morgan',
        description:
          'A steamy vampire romance with forbidden love and dangerous secrets.',
        coverDesigner: 'Elena Ramirez',
        coverDesignerId: 'elena-ramirez',
        formatter: 'TypeSet Studios',
        formatterId: 'typeset-studios',
        tropes: [
          'Forbidden Love',
          'Vampires',
          'Fated Mates',
          'Enemies to Lovers',
        ],
        contentWarnings: ['Blood', 'Violence', 'Explicit Sexual Content'],
        spiceLevel: 4,
      },
      {
        title: "Shadow's Call",
        author: 'Jared Wolf',
        authorId: 'jared-wolf',
        description:
          'A novella featuring a protective werewolf and his fated mate.',
        coverDesigner: 'Marcus Chen',
        coverDesignerId: 'marcus-chen',
        formatter: 'BookFormat Pro',
        formatterId: 'bookformat-pro',
        tropes: ['Werewolves', 'Fated Mates', 'Protective Hero'],
        contentWarnings: ['Violence', 'Explicit Sexual Content'],
        spiceLevel: 3,
      },
    ],
    items: [
      'Vampire-themed scented candle',
      'Exclusive bookmark set',
      'Blood-red bath bomb',
      'Character art print',
      'Moon phase enamel pin',
    ],
    artists: [
      {
        name: 'Luna Crafts',
        id: 'luna-crafts',
        items: ['Vampire-themed scented candle', 'Blood-red bath bomb'],
      },
      {
        name: 'Mystic Art',
        id: 'mystic-art',
        items: ['Character art print', 'Exclusive bookmark set'],
      },
    ],
    testimonials: [
      {
        name: 'Sarah K.',
        comment:
          'The vampire romance was exactly what I needed! Loved all the themed items too.',
      },
    ],
  },
  {
    id: 2,
    name: "March 2023: 'Tropical Heat'",
    boxName: 'Bookish & Spice',
    theme: 'Beach Romance',
    description:
      'Our March box transported readers to sandy beaches and tropical destinations with steamy vacation romances.',
    image:
      'https://images.unsplash.com/photo-1528150177508-7cc0c36cda5c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800',
    books: [
      {
        title: 'Island Affair',
        author: 'Maya Summers',
        authorId: 'maya-summers',
        description:
          'A steamy vacation fling turns into something more on a tropical island.',
        coverDesigner: 'Sophia Lee',
        coverDesignerId: 'sophia-lee',
        formatter: 'PagePerfect',
        formatterId: 'pageperfect',
        tropes: ['Vacation Romance', 'Forced Proximity', 'Billionaire'],
        contentWarnings: ['Explicit Sexual Content'],
        spiceLevel: 4,
      },
    ],
    items: [
      'Coconut-scented candle',
      'Beach-themed bookmark',
      'Tropical cocktail bath salts',
      'Sunglasses pouch',
      'Flamingo pen',
    ],
    artists: [
      {
        name: 'Coastal Creations',
        id: 'coastal-creations',
        items: ['Coconut-scented candle', 'Tropical cocktail bath salts'],
      },
      {
        name: 'Beachy Things',
        id: 'beachy-things',
        items: ['Beach-themed bookmark', 'Flamingo pen'],
      },
    ],
    testimonials: [
      {
        name: 'Jessica T.',
        comment:
          'This box was like a mini vacation! The book was so steamy and I loved the tropical scented items.',
      },
    ],
  },
  {
    id: 3,
    name: "February 2023: 'Forbidden Desires'",
    boxName: 'Bookish & Spice',
    theme: 'Taboo Romance',
    description:
      "Our Valentine's box explored forbidden romances with age gaps, power dynamics, and taboo relationships.",
    image:
      'https://images.unsplash.com/photo-1518558997970-4ddc236affcd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800',
    books: [
      {
        title: "The Professor's Desire",
        author: 'Elizabeth Chase',
        authorId: 'elizabeth-chase',
        description:
          'A steamy forbidden romance between a professor and his graduate student.',
        coverDesigner: 'David Wright',
        coverDesignerId: 'david-wright',
        formatter: 'Elite Formatting',
        formatterId: 'elite-formatting',
        tropes: [
          'Age Gap',
          'Forbidden Romance',
          'Power Imbalance',
          'Academic Setting',
        ],
        contentWarnings: ['Explicit Sexual Content', 'Power Imbalance'],
        spiceLevel: 5,
      },
    ],
    items: [
      'Rose and chocolate scented candle',
      'Satin bookmark',
      'Red wine bath bomb',
      'Handcuffs enamel pin',
      'Chocolate truffles',
    ],
    artists: [
      {
        name: 'Sensual Scents',
        id: 'sensual-scents',
        items: ['Rose and chocolate scented candle', 'Red wine bath bomb'],
      },
      {
        name: 'Forbidden Art',
        id: 'forbidden-art',
        items: ['Satin bookmark', 'Handcuffs enamel pin'],
      },
    ],
    testimonials: [
      {
        name: 'Melissa R.',
        comment:
          'This was my first box and WOW! The book was incredibly steamy and the items were perfect.',
      },
    ],
  },
]
export const fantasyPastBoxes: PastBox[] = [
  {
    id: 1,
    name: "April 2023: 'Dragon Kingdoms'",
    boxName: 'Fantasy Realm Crate',
    theme: 'Dragon Fantasy',
    description:
      'Our April box celebrated all things dragons with epic adventures and magical realms.',
    image:
      'https://images.unsplash.com/photo-1550859492-d5da9d8e45f3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800',
    books: [
      {
        title: "Dragon Rider's Oath",
        author: 'Elias Blackwood',
        authorId: 'elias-blackwood',
        description:
          'An epic fantasy about a reluctant hero who bonds with the last dragon queen.',
        coverDesigner: 'Victoria Grant',
        coverDesignerId: 'victoria-grant',
        formatter: 'Fantasy Formats',
        formatterId: 'fantasy-formats',
        tropes: [
          'Chosen One',
          'Dragon Riders',
          'Reluctant Hero',
          'Coming of Age',
        ],
        contentWarnings: ['Violence', 'Mild Gore'],
        spiceLevel: 1,
      },
    ],
    items: [
      'Dragon scale bookmark',
      'Dragon eye candle holder',
      'Fantasy map art print',
      'Dragon enamel pin',
      'Leather journal',
    ],
    artists: [
      {
        name: 'Dragon Forge',
        id: 'dragon-forge',
        items: ['Dragon scale bookmark', 'Dragon enamel pin'],
      },
      {
        name: 'Realm Cartography',
        id: 'realm-cartography',
        items: ['Fantasy map art print'],
      },
      {
        name: 'Mythic Crafts',
        id: 'mythic-crafts',
        items: ['Dragon eye candle holder', 'Leather journal'],
      },
    ],
    testimonials: [
      {
        name: 'Michael T.',
        comment:
          'The dragon theme was executed perfectly! The book was amazing and the collectibles are displayed proudly on my shelf.',
      },
    ],
  },
  {
    id: 2,
    name: "March 2023: 'Enchanted Forests'",
    boxName: 'Fantasy Realm Crate',
    theme: 'Forest Magic',
    description:
      'Our March box took readers into magical forests with fae, magical creatures, and ancient mysteries.',
    image:
      'https://images.unsplash.com/photo-1502082553048-f009c36cda5c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800',
    books: [
      {
        title: "The Fae King's Promise",
        author: 'Serena Woodlands',
        authorId: 'serena-woodlands',
        description:
          'A captivating tale of a mortal who becomes entangled in fae politics and magic.',
        coverDesigner: 'Nathan Pierce',
        coverDesignerId: 'nathan-pierce',
        formatter: 'Mystic Pages',
        formatterId: 'mystic-pages',
        tropes: [
          'Fae',
          'Mortal in Magical World',
          'Forbidden Love',
          'Court Politics',
        ],
        contentWarnings: ['Mind Manipulation', 'Violence'],
        spiceLevel: 2,
      },
    ],
    items: [
      'Forest-scented candle',
      'Wooden bookmark',
      'Mushroom tea infuser',
      'Leaf-shaped soap',
      'Fairy light string',
    ],
    artists: [
      {
        name: 'Woodland Wonders',
        id: 'woodland-wonders',
        items: ['Forest-scented candle', 'Leaf-shaped soap'],
      },
      {
        name: 'Fae Crafts',
        id: 'fae-crafts',
        items: ['Wooden bookmark', 'Mushroom tea infuser'],
      },
    ],
    testimonials: [
      {
        name: 'Emma L.',
        comment:
          'This box transported me straight into an enchanted forest! The attention to detail was incredible.',
      },
    ],
  },
]
export const upcomingBoxes: Record<string, UpcomingBox[]> = {
  'Bookish & Spice': [
    {
      id: 1,
      name: "May 2023: 'Royal Affairs'",
      theme: 'Royal Romance',
      description:
        'Our May box will feature steamy royal romances with princes, dukes, and forbidden palace affairs.',
      image:
        'https://images.unsplash.com/photo-1587142930903-4d4c1c8b4022?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800',
      books: [
        {
          title: "The Duke's Secret",
          author: 'Charlotte Pembrooke',
          authorId: 'charlotte-pembrooke',
          coverDesigner: 'Royal Designs',
          coverDesignerId: 'royal-designs',
          formatter: 'Noble Formats',
          formatterId: 'noble-formats',
          tropes: ['Royal Romance', 'Secret Identity', 'Forbidden Love'],
          contentWarnings: ['Explicit Sexual Content', 'Mild Violence'],
          spiceLevel: 4,
          releaseDate: '2023-05-15',
        },
      ],
      teaserItems: [
        'Crown-themed item',
        'Royal tea blend',
        'Exclusive character art',
        'And more surprises!',
      ],
      artists: [
        {
          name: 'Royal Artisans',
          id: 'royal-artisans',
          items: ['Crown-themed item', 'Exclusive character art'],
        },
        {
          name: 'Tea Royale',
          id: 'tea-royale',
          items: ['Royal tea blend'],
        },
      ],
      releaseDate: 'May 15-20, 2023',
      cutoffDate: 'May 1, 2023',
    },
    {
      id: 2,
      name: "June 2023: 'Summer Heat'",
      theme: 'Summer Romance',
      description:
        'Get ready for hot summer nights with our June box featuring beach romances and vacation flings.',
      image:
        'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800',
      books: [
        {
          title: 'Summer Nights',
          author: 'Jasmine Rivera',
          authorId: 'jasmine-rivera',
          coverDesigner: 'Sunset Designs',
          coverDesignerId: 'sunset-designs',
          formatter: 'Beach Formats',
          formatterId: 'beach-formats',
          tropes: ['Summer Romance', 'Vacation Fling', 'Second Chance'],
          contentWarnings: ['Explicit Sexual Content'],
          spiceLevel: 4,
          releaseDate: '2023-06-15',
        },
      ],
      teaserItems: [
        'Beach-themed goodies',
        'Summer cocktail mix',
        'Exclusive summer romance novel',
        'And more surprises!',
      ],
      artists: [
        {
          name: 'Summer Crafts',
          id: 'summer-crafts',
          items: ['Beach-themed goodies'],
        },
        {
          name: 'Cocktail Creations',
          id: 'cocktail-creations',
          items: ['Summer cocktail mix'],
        },
      ],
      releaseDate: 'June 15-20, 2023',
      cutoffDate: 'June 1, 2023',
    },
  ],
  'Fantasy Realm Crate': [
    {
      id: 1,
      name: "May 2023: 'Elemental Magic'",
      theme: 'Elemental Fantasy',
      description:
        'Discover the power of the elements with our May box featuring magic systems and elemental wielders.',
      image:
        'https://images.unsplash.com/photo-1519681393784-d120267933ba?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800',
      books: [
        {
          title: 'Elemental Awakening',
          author: 'Kai Winters',
          authorId: 'kai-winters',
          coverDesigner: 'Element Designs',
          coverDesignerId: 'element-designs',
          formatter: 'Arcane Formats',
          formatterId: 'arcane-formats',
          tropes: ['Elemental Magic', 'Chosen One', 'Hidden Powers'],
          contentWarnings: ['Violence', 'Natural Disasters'],
          spiceLevel: 1,
          releaseDate: '2023-05-15',
        },
      ],
      teaserItems: [
        'Element-themed candle',
        'Magical map',
        'Enchanted bookmark',
        'And more surprises!',
      ],
      artists: [
        {
          name: 'Elemental Crafts',
          id: 'elemental-crafts',
          items: ['Element-themed candle', 'Enchanted bookmark'],
        },
        {
          name: 'Magical Cartography',
          id: 'magical-cartography',
          items: ['Magical map'],
        },
      ],
      releaseDate: 'May 15-20, 2023',
      cutoffDate: 'May 1, 2023',
    },
  ],
}
export const faqItems: FAQItem[] = [
  {
    question: 'When will my box ship?',
    answer:
      "Boxes typically ship between the 15th-20th of each month. You'll receive a shipping confirmation email with tracking information once your box is on its way.",
  },
  {
    question: 'Can I skip a month?',
    answer:
      "Yes! You can skip any month by logging into your account and selecting 'Skip' for the upcoming box. You must skip before the 1st of the month to avoid being charged.",
  },
  {
    question: "What's your refund policy?",
    answer:
      "We don't offer refunds for boxes, but if your box arrives damaged or is missing items, please contact us within 7 days of delivery and we'll make it right.",
  },
  {
    question: 'Are the books always new releases?',
    answer:
      'Our boxes typically feature new releases from the current month or recent bestsellers. Occasionally we may include a backlist title if it fits perfectly with our theme.',
  },
  {
    question: 'How do I update my shipping address?',
    answer:
      'You can update your shipping address in your account settings. Please make any changes before the 5th of the month to ensure your box is sent to the correct address.',
  },
  {
    question: 'How do I manage my subscriptions?',
    answer:
      'You can manage all your subscriptions from your account settings under "My Subscriptions". There you can pause, skip, or cancel subscriptions as needed.',
  },
]
export const getPastBoxesByName = (boxName: string): PastBox[] => {
  if (boxName === 'Bookish & Spice') {
    return pastBoxes
  } else if (boxName === 'Fantasy Realm Crate') {
    return fantasyPastBoxes
  }
  return []
}
export const getUpcomingBoxesByName = (boxName: string): UpcomingBox[] => {
  return upcomingBoxes[boxName] || []
}
